<mat-chip-list>
  <mat-chip size="sm" *ngFor="let item of items; trackBy: trackBy" class="callSignChips">
    <div class="callSignchipLabel">
      <span>
        {{ item.name }}
      </span>
    </div>
  </mat-chip>
</mat-chip-list>
